import React, {useEffect, useState} from "react";
import useMobileAccess from "../../hooks/useMobileAccess";
import {
    TEXTBOX, WAIT_QUESTION_EXPLAIN,
    WAITING_ROOM_ACTIVITY_TEXT,
    WAITING_ROOM_WAIT_POLL_START_DESC,
} from "../../utils/constants";
import { newPageLog } from "../../utils/helpers";
import "./styles.css";
import PollTitleContainer from "./PollTitleContainer";
import styles from "./styles.module.css";
import IllustrationWrapper from "./IllustrationWrapper";
import { ReactComponent as QUESTION_ICON } from "./images/question-icon.svg";
import waiting from "./animations/waitingRoom.json";
import Lottie from "react-lottie";
import useWindowDimensions from "../../hooks/useWindowDimensions";

export default function WaitingRoom({ bodyText, bodyShareCount, titleText, afterQ, loadingDelay }) {

    const windowDimensions = useWindowDimensions();

    const getImageSize = () => {
        let {width, height} = windowDimensions;
        let adjustedWidth = Math.min(width * 0.3, 300);
        let adjustedHeight = Math.min(height * 0.3, 300);

        return Math.min(adjustedWidth, adjustedHeight);
    }

    const isNarrow = useMobileAccess(1200);
    const [imageSize, setImageSize] = useState(() => getImageSize())

    const LottieOptions = {
        loop: true,
        autoplay: true,
        animationData: waiting,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        }
    };

    useEffect(() => {
        newPageLog("WaitingRoom.js");
        if (isNarrow && document.getElementById("viewer-navbar-container") !== null) {
            document.getElementById("viewer-navbar-container").style.backgroundColor = "#FCFBFF";
        }
    }, []);

    useEffect(() => {
        setImageSize(getImageSize());
    }, [windowDimensions]);

    return (
        <div className={styles.generalContainer} style={{height: "unset", flex: 1}}>
            <PollTitleContainer pollTitle={loadingDelay ? null : titleText}/>
            <span style={{flex: 1}}/>
            <div className={styles.waitingIllustrationContainer}>
                <IllustrationWrapper>
                    <Lottie
                        options={LottieOptions}
                        height={200}
                        style={{overflow: 'unset', width: "unset", cursor: "default"}}
                        isClickToPauseDisabled={true}
                    />
                </IllustrationWrapper>
            </div>

            {bodyShareCount &&
                <div className={styles.questionSharedBadge}>
                    <QUESTION_ICON/>
                    <span>Questions - {bodyShareCount}</span>
                </div>
            }
            {!loadingDelay && !!titleText &&
                <span className={styles.waitingRoomTitle}>
                  {bodyText}
              </span>
            }

            {!!afterQ &&
                <span className={styles.waitingRoomDesc}>{WAIT_QUESTION_EXPLAIN}</span>
            }

            {!afterQ &&
                <span className={styles.waitingRoomDesc}>
                {(loadingDelay || !titleText) ? WAITING_ROOM_ACTIVITY_TEXT : WAITING_ROOM_WAIT_POLL_START_DESC}
            </span>
            }
            <span style={{flex: 2}}/>
        </div>
    );
}
